module.exports = __webpack_public_path__ + "img/goods6_1.231365c2.jpg";